const styles = theme => ({
  card: {
    borderRadius: '16px',
    background: '#fff',
    padding: '24px',
    height: '240px',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: theme.font.family.secondary,
    color: theme.palette.dark,

    [theme.breakpoints.down('sm')]: {
      height: 'initial',
    },
  },
  header: {
    display: 'flex',
    marginBottom: '32px',
  },
  title: {
    fontSize: theme.font.sizes.lg,
    fontWeight: theme.font.weights.medium,
    margin: 0,
    marginRight: '10px',
  },
  content: {
    flex: 1,
    marginBottom: '32px',
    [theme.breakpoints.down('md')]: {
      alignSelf: 'center',
    },
  },
  contentLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  warning: {
    padding: '15px',
    borderRadius: '2px',
  },
  warningLink: {
    color: theme.color.indigo,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '16px',
  },
  btnHistory: {
    borderColor: theme.color.geyser,
    marginRight: '10px',
    color: theme.color.indigo,
  },
  btnLoading: {
    fontSize: '14px',
    color: theme.color.tundora,
  },
  loader: {
    marginRight: '5px',
    color: theme.color.tundora,
  },
});

export default styles;
